import { render, staticRenderFns } from "./PanelRight.vue.js?vue&type=template&id=287be284&scoped=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PanelRight.vue?vue&type=template&id=287be284&scoped=true"
import script from "./PanelRight.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PanelRight.vue?vue&type=script&lang=js"
export * from "./PanelRight.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PanelRight.vue?vue&type=script&lang=js"
import style0 from "./PanelRight.vue.scss?vue&type=style&index=0&id=287be284&prod&scoped=true&lang=scss!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PanelRight.vue?vue&type=style&index=0&id=287be284&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287be284",
  null
  
)

export default component.exports